import { DeviceEnabledType, UserAttributeDefs } from '@iotv/datamodel-core'
import { yesNo } from '@iotv/iotv-v3-types'
import { ErrorType } from '../../types'

const typeName = 'EffluentSpreader'

export class EffluentSpreader extends DeviceEnabledType {
  constructor(ob: any) {
    super(ob.type || typeName, ob)
  }

  deviceEui?: string
  // From DeviceNWAttributes
  sf?: number | undefined
  rssi?: number | undefined
  snr?: number | undefined
  gatewayEui?: string | undefined

  // from V020 payload

  firmwareCode?: number
  margin?: number
  moisture?: number
  sysTime?: number
  temperature?: number
  error?: ErrorType
  throwArea: number | undefined
  isOperating?: boolean
  updated_at?: number

  get batteryErr() {
    return this.error?.batteryErr
  }
  set batterErr(err: yesNo) {
    this.error && err !== undefined && (this.error.batteryErr = err)
  }

  get linkCheckErr() {
    return this.error?.linkCheckErr
  }
  set linkCheckErr(err: yesNo | undefined) {
    this.error && err !== undefined && (this.error.linkCheckErr = err)
  }

  get timeNotSet() {
    return this.error?.timeNotSet
  }
  set timeNotSet(err: yesNo | undefined) {
    this.error && err !== undefined && (this.error.timeNotSet = err)
  }

  get travellingCurrentLocation_lat() {
    return this.travellingCurrentLocation?.lat ?? 0
  }
  set travellingCurrentLocation_lat(val: number) {
    if (!this.travellingCurrentLocation) Object.assign(this, { travellingCurrentLocation: {} })
    if (this.travellingCurrentLocation) this.travellingCurrentLocation.lat = val
    this.setDskFromLocation()
  }

  get travellingCurrentLocation_lng() {
    return this.travellingCurrentLocation?.lng ?? 0
  }
  set travellingCurrentLocation_lng(val: number) {
    if (!this.travellingCurrentLocation) Object.assign(this, { travellingCurrentLocation: {} })
    if (this.travellingCurrentLocation) this.travellingCurrentLocation.lng = val
    this.setDskFromLocation()
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        label: 'Name',
        name: 'name',
        description: 'Name of sprinkler',
      },

      travellingCurrentLocation_lat: {
        type: 'Number',
        precision: 5,
        label: 'Travelling Lat',
      },
      travellingCurrentLocation_lng: {
        type: 'Number',
        precision: 5,
        label: 'Travelling Lng',
      },
      throwArea: {
        type: 'Number',
        editable: true,
        label: 'Throw Area',
        name: 'throwArea',
        description: 'Effluent spread throw distance',
      },
      hasDevice: {
        type: 'Boolean',
        editable: false,
        label: 'Has Linked Device',
        name: 'hasDevice',
        description: 'If the irrigator has an associated device',
      },
      /**
       * check whether dot access was enabled in Tabilizer?
       */
      isOperating: {
        name: 'isOperating',
        type: 'Boolean',
        editable: false,
        label: 'Operating State',
        description: 'If the irrigator is operating',
      },
      updated_at: {
        type: 'Date',
        editable: false,
        label: 'Last Update',
        name: 'lastUpdate',
        description: 'When it was last updated',
      },
    }
  }
}
